/**
 * Preview stills for library sketches, rendered through the shader runtime with
 * default params over `public/mock/node-images/6.jpg`. One file per sketch id.
 *
 * Loaded lazily so the thumbnails stay out of the main bundle until a library
 * grid actually renders them.
 */
const loaders = import.meta.glob<string>('./thumbnails/*.webp', { query: '?url', import: 'default' })

/** Resolve a sketch's thumbnail URL, or `undefined` when it has none. */
export function loadSketchThumbnail(id: string): Promise<string> | undefined {
  return loaders[`./thumbnails/${id}.webp`]?.()
}
